import React from 'react'
import { observer } from 'mobx-react'
import { Modal, Checkbox } from 'react-bootstrap'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import * as defaultConst from '../../../constants/default_constants'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const EpisodesSeriesGenModal = observer(({ store, seasonsSize, episodesSize }) => {
  const state = store.cv.subentities.seriesEpisodesGen
  const updateFormField = store.updateSubentityField.bind(store, state, store.cv.items)

  if (store.episodes_series_gen_modal.justOpened) {
    if (store.episodes_series_gen_modal.mode === 'seasons') {
      updateFormField('from', seasonsSize + 1)
    } else {
      updateFormField('from', episodesSize(store.episodes_series_gen_modal.parentId) + 1)
    }
    updateFormField('to', '')
    store._runSubentityValidators(state)
    store._runSubentityGlobalValidator(state)
    store.episodes_series_gen_modal.justOpened = false
  }

  return (
    <Modal show backdrop='static' onHide={() => store.toggleEpisodesSeriesGenModal()}>
      <Modal.Header closeButton>
        <Modal.Title>
          {store.__(`Generate ${store.episodes_series_gen_modal.mode}`)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextInput
          label={store.__('From')}
          attr={'from'}
          type='number'
          record={state.record}
          onChange={updateFormField}
          errors={state.errors}
        />
        <TextInput
          label={store.__('To')}
          attr={'to'}
          type='number'
          record={state.record}
          onChange={updateFormField}
          errors={state.errors}
        />
        <BoolInput
          label={store.__('Add series/episode number into "English distribution title" (e.g. Title - S01 E01)?')}
          attr={'title_type'}
          record={state.record}
          onChange={updateFormField}
        />

        {
          state.errors.has('_global') && (
            <div className='alert alert-danger fade in'>
              <strong>Error! </strong>
              {state.errors.get('_global')}
            </div>
          )
        }

        {
          !store.episodes_series_gen_modal.parentId ? (
            <div className='alert alert-danger fade in'>
              <strong>Error! </strong>
              {store.__(`${store.episodes_series_gen_modal.mode === 'seasons' ? 'Series' : 'Season'} must be saved first!`)}
            </div>
          ) : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          <button
            disabled={state.errors.size > 0 || !store.episodes_series_gen_modal.parentId}
            type='button' className='btn btn-primary'
            onClick={() => store.generateEpisodesSeries()}>
            {store.__('Submit')}
          </button>
          <button type='button' className='btn btn-default'
            onClick={() => store.toggleEpisodesSeriesGenModal()}>
            {store.__(defaultConst.TITLE_CANCEL)}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
})

class CommonEditForm extends React.Component {
  render () {
    const { store, originalSeriesId, isEpisode, isSeason, isSeries, assetRefs } = this.props

    const seasonIndent = { paddingLeft: '25px' }
    const episodeIndent = { paddingLeft: '50px' }
    const currentItemStyles = { fontWeight: 'bold' }
    const reverseOrder = (store.cv.record && store.cv.record.has('reverseOrder') && store.cv.record.get('reverseOrder')) || {}
    const hasID = store.cv.record && store.cv.record.has('id') && parseInt(store.cv.record.get('id'))
    const seasonsSize = store.options.get('seasons').filter(i => i.parent_id && i.parent_id === originalSeriesId).length
    const episodesSize = jID => store.options.get('episodes').filter(i => i.parent_id && i.parent_id === jID).length
    const confirmText = store.__('Change all seasons "reverse order" flags in same way?')

    const setReverseOrder = (k, v, all = false) => {
      k = parseInt(k)
      reverseOrder[k] = v
      if (all) {
        store.options.get('seasons')
          .filter(i => i.parent_id && parseInt(i.parent_id) === k)
          .map(j => {
            if (hasID === parseInt(j.id)) {
              store.cv.record.set('reverse_order', v)
            }
            reverseOrder[j.id] = v
          })
      }
      if (hasID === k) {
        store.cv.record.set('reverse_order', v)
      }
    }

    const seriesHeaderItem = store.options.get('films')
      .filter(f => f.video_type === 'SERIES' && f.id && f.id === originalSeriesId)
      .map(j => {
        const isChecked = reverseOrder && reverseOrder[j.id] !== undefined ? reverseOrder[j.id] : j.reverse_order
        return (
          <tr key={j.id}>
            <td>{store.__('series')}</td>
            <td></td><td></td>
            <td>
              <a style={isSeries && store.cv.record.get('id') === j.id ? currentItemStyles : null} href='javascript:void(0)' onClick={() => {
                if (store.beforeEditViewExit()) {
                  store.goTo('entity_detail', { entityname: 'films', id: j.id })
                }
              }}><span className='glyphicon glyphicon-share-alt' />&nbsp;{j.title || j.id}</a>
            </td>
            <td><Checkbox checked={isChecked}
              onClick={() => window.confirm(confirmText) ? setReverseOrder(j.id, !isChecked, true) : setReverseOrder(j.id, !isChecked, false)}>
              {store.__('Show all seasons in reverse order')}
            </Checkbox>
            </td>
            <td>
              {seasonsSize}
            </td>
            <td className='series-tab-fixed-column'>
              <button type='button' className='btn btn-primary btn-xs'
                onClick={() => store.toggleEpisodesSeriesGenModal({ mode: 'seasons', justOpened: true, parentId: j.id, reverseOrder: isChecked })}>
                <span className='glyphicon glyphicon-plus' />&nbsp; Seasons
              </button>
            </td>
          </tr>
        )
      })

    const seasonParentOrder = (reverseOrder && reverseOrder[originalSeriesId] !== undefined)
      ? reverseOrder[originalSeriesId]
      : store.options.get('films').find(i => i.id && i.id === originalSeriesId) && store.options.get('films').find(i => i.id && i.id === originalSeriesId).reverse_order
    const seasonList = (isSeries || isSeason || isEpisode) && originalSeriesId && store.options.get('seasons')
      .filter(i => i.parent_id && i.parent_id === originalSeriesId)
      .sort((a, b) => (seasonParentOrder ? b.season_no - a.season_no : a.season_no - b.season_no))
      .map(j => {
        const episodeParentOrder = (reverseOrder && reverseOrder[j.id] !== undefined) ? reverseOrder[j.id] : (store.options.has('films') && store.options.get('films').find(i => i.id && i.id === j.id) && store.options.get('films').find(i => i.id && i.id === j.id).reverse_order)
        const isChecked = (reverseOrder && reverseOrder[j.id] !== undefined) ? reverseOrder[j.id] : j.reverse_order

        return (<React.Fragment key={j.id}>
          <tr ref={el => { assetRefs[j.id] = el }} key={j.id}>
            <td>{store.__('season')}</td>
            <td>{j.season_no && j.season_no.toString() ? ` ${j.season_no}` : ''}</td><td></td>
            <td>
              <a style={{ ...seasonIndent, ...(isSeason && store.cv.record.get('id') === j.id ? currentItemStyles : []) }} href='javascript:void(0)' onClick={() => {
                if (store.beforeEditViewExit()) {
                  store.goTo('entity_detail', { entityname: 'films', id: j.id })
                }
              }}><span className='glyphicon glyphicon-share-alt' />&nbsp;{j.title || j.id}</a>
            </td>
            <td><Checkbox checked={isChecked} onClick={() => setReverseOrder(j.id, !isChecked, false)}>
              {store.__('Show episodes of this season in reverse order')}
            </Checkbox>
            </td>
            <td>
              {episodesSize(j.id)}
            </td>
            <td className='series-tab-fixed-column'>
              <button type='button' className='btn btn-primary btn-xs'
                onClick={() => store.toggleEpisodesSeriesGenModal({ mode: 'episodes', justOpened: true, parentId: j.id })}>
                <span className='glyphicon glyphicon-plus' />&nbsp; Episodes
              </button>
            </td>
          </tr>
          {
            store.options.get('episodes')
              .filter(i => i.parent_id && i.parent_id === j.id)
              .sort((a, b) => (episodeParentOrder ? b.episode_no - a.episode_no : a.episode_no - b.episode_no))
              .map(j => {
                return (<tr ref={el => { assetRefs[j.id] = el }} key={j.id}>
                  <td>{store.__('episode')}</td>
                  <td>{store.options.get('seasons').find(i => i.id && i.id === j.parent_id).season_no}</td>
                  <td>{j.episode_no && j.episode_no.toString() ? ` ${j.episode_no}` : ''}</td>
                  <td>
                    <a style={{ ...episodeIndent, ...(isEpisode && store.cv.record.get('id') === j.id ? currentItemStyles : []) }} href='javascript:void(0)' onClick={() => {
                      if (store.beforeEditViewExit()) {
                        store.goTo('entity_detail', { entityname: 'films', id: j.id })
                      }
                    }}><span className='glyphicon glyphicon-share-alt' />&nbsp;{j.title || j.id}</a>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>)
              })
          }
        </React.Fragment>)
      })

    return (
      <div className='table-responsive'>
        <table className='table table-hover table-striped table-condensed'>
          <thead>
            <tr>
              <th>{store.__('Type')}</th>
              <th>{store.__('Season')}</th>
              <th>{store.__('Episode')}</th>
              <th>{store.__('Title')}</th>
              <th>{store.__('Reverse order')}</th>
              <th>{store.__('Count')}</th>
              <th>{store.__('Action')}</th>
            </tr>
          </thead>
          <tbody>
            {seriesHeaderItem}
            {!seasonList || !seasonList.length > 0 ? null : seasonList}
          </tbody>
        </table>
        {!seasonList || !seasonList.length > 0 ? (
          <div className='form-group'>
            <em>- {store.__('Seasons/episodes are not yet assigned')} -</em>
          </div>
        ) : null}
        {store.episodes_series_gen_modal
          ? <EpisodesSeriesGenModal store={store} seasonsSize={seasonsSize} episodesSize={episodesSize} />
          : null}
      </div>
    )
  }
}

export default observer(CommonEditForm)
